/* boroj-cart-state.js
   One shared cart-state layer for all boroj sections.
   - Collapses N parallel /cart.js fetches into ONE per mutation.
   - Re-broadcasts a NATIVE `cart:updated` event carrying a populated {cart} detail,
     so boroj bars (tier-bar, shipping-bar, PDP shipping) render WITHOUT each fetching.
   - Exposes window.BorojCart.added() to refresh the Monkeys Marketing Theme mini-cart + open its drawer
     instead of a full-page reload.

   Note: the Monkeys Marketing Theme listens to `cart:refresh` natively (interactable.min.js) and
   rebuilds the #t4s-mini_cart drawer itself. We piggyback on that event; this module adds
   exactly ONE more fetch to obtain the cart JSON the bars need. */
(function () {
  'use strict';

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
        return cart;
      })
      .catch(function () { return null; });
  }

  /* Open the Monkeys Marketing Theme cart drawer by clicking its toggle (graceful no-op if absent). */
  function open() {
    var toggle = document.querySelector('[data-drawer-options*="t4s-mini_cart"]');
    if (toggle) { toggle.click(); return true; }
    return false;
  }

  /* Call after a boroj AJAX add: rebuild the theme drawer + boroj bars, then slide it open. */
  function added() {
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    open();
  }

  /* When anything asks for a refresh WITHOUT a payload, fetch once and re-broadcast with the cart.
     Guard against the event we ourselves cause via cart:updated. */
  document.addEventListener('cart:refresh', function (e) {
    if (e && e.detail && e.detail.cart) return; /* already carries the cart */
    refresh();
  });

  window.BorojCart = { refresh: refresh, open: open, added: added };
})();
